export enum WebLeadType {
  WEB_LEAD_1 = 'web_lead_1',
  WEB_LEAD_2 = 'web_lead_2',
  WEB_LEAD_3 = 'web_lead_3',
  // Otherwise known as a Ninja lead
  WEB_LEAD_4 = 'web_lead_4',
  // Early Exit lead
  EARLY_EXIT_WEB_SURVEY = 'early_exit_web_survey',
  ONLINE_ACTIVATION_STARTED = 'online_activation_started'
}
